import Constants from '../constants';
import produce from "immer";
import { UpdateArray, UpdateArrayRange } from '../misc/ArrayFuncs';
const initDataState = [];

const ContImprove = (state = initDataState, action) => {
    switch (action.type) {
        case Constants.Actions.RequestContImprove:
            return state;
        case Constants.Actions.ReceiveContImprove:
            return UpdateArrayRange(action.data, state);
        case Constants.Actions.ContImprove_GetByVisitID:
            const nonPlantContImprove = state.filter(a => a.visitId !== action.visitId);
            return nonPlantContImprove.concat(action.data);

        case Constants.Actions.ContImprove.Add:
            return UpdateArray(action.payload, state);
            
        case Constants.Actions.ContImprove.Add_Commit:
            return UpdateArray(action.payload?.data, state);


        case Constants.Actions.ContImprove.Add_Rollback:
            const baseInd = state.findIndex(v => v.id === action.meta.newContImproveItem.id);
            if (baseInd !== -1) {
                return produce(state, pd => { pd.splice(baseInd, 1) });
            } else {
                return state;
            }



        case Constants.Actions.ContImprove.Update:
            return UpdateArray(action.payload.update, state);
        case Constants.Actions.ContImprove.Update_Commit:
            return UpdateArray(action.payload?.data, state);
        case Constants.Actions.ContImprove.Update_Rollback:
            return UpdateArray(action.meta.data.current, state);
        case Constants.Actions.ContImprove.Delete:
            return UpdateArray(produce(action.payload, d => {
                d.deleted = true;
            }), state);
        case Constants.Actions.ContImprove.Delete_Commit:
            return state;
        case Constants.Actions.ContImprove.Delete_Rollback:
            return UpdateArray(action.meta.delKeyItem, state);
        case Constants.Actions.ContImprove.ClearData:
            return initDataState;
        default:
            return state;
    }
}
export default ContImprove;